import React from "react";
import Lottie from "lottie-react";
import TextBox from '../../../../components/mui/text/TextBox';
import NoData from '../../../../assets/lotties/NoData.json'

const FamilyDetails = ({ familyData, loading }) => {

    const fatherData = [
        { label: 'Name', value: `${familyData?.fatherDetail?.title} ${familyData?.fatherDetail?.firstName} ${familyData?.fatherDetail?.middleName ?? ""} ${familyData?.fatherDetail?.lastName}` },
        { label: 'Phone Number', value: familyData?.fatherDetail?.phNo },
        { label: 'Email ID', value: familyData?.fatherDetail?.emailId },
        { label: 'Education', value: familyData?.fatherDetail?.education },
        { label: 'Profession', value: familyData?.fatherDetail?.profession },
        { label: 'Income', value: familyData?.fatherDetail?.income },
    ]
    const motherData = [
        { label: 'Name', value: `${familyData?.motherDetail?.title} ${familyData?.motherDetail?.firstName} ${familyData?.motherDetail?.middleName ?? ""} ${familyData?.motherDetail?.lastName}` },
        { label: 'Phone Number', value: familyData?.motherDetail?.phNo },
        { label: 'Email ID', value: familyData?.motherDetail?.emailId },
        { label: 'Education', value: familyData?.motherDetail?.education },
        { label: 'Profession', value: familyData?.motherDetail?.profession },
        { label: 'Income', value: familyData?.motherDetail?.income },
    ]
    const guardianData = [
        { label: 'Name', value: `${familyData?.guardianDetail?.title} ${familyData?.guardianDetail?.firstName} ${familyData?.guardianDetail?.middleName ?? ""} ${familyData?.guardianDetail?.lastName}` },
        { label: 'Phone Number', value: familyData?.guardianDetail?.phNo },
        { label: 'Email ID', value: familyData?.guardianDetail?.emailId },
        { label: 'Education', value: familyData?.guardianDetail?.education },
        { label: 'Profession', value: familyData?.guardianDetail?.profession },
        { label: 'Income', value: familyData?.guardianDetail?.income }
    ]
    const emergencyPersonData = [
        { label: 'Name', value: `${familyData?.emergencyPersonDetail?.title} ${familyData?.emergencyPersonDetail?.firstName} ${familyData?.emergencyPersonDetail?.middleName ?? ""} ${familyData?.emergencyPersonDetail?.lastName}` },
        { label: 'Phone Number', value: familyData?.emergencyPersonDetail?.phNo },
        { label: 'Relation', value: familyData?.emergencyPersonDetail?.relation },
    ]


    return (
        <div className='flex flex-col w-full gap-8'>
            {(loading || !familyData?.fatherDetail?.isDeceased) && <>
                <div className="flex flex-col gap-5">
                    <div className='flex items-center gap-4'>
                        <p className='lb-s whitespace-nowrap'>Father Details</p>
                        <hr className='block lg:hidden w-full h-0.5 bg-slate-400' />
                    </div>
                    <div className='grid grid-cols-1 sm:grid-cols-2 tab:grid-cols-3 gap-5 ml-1'>
                        {fatherData?.map((field, index) => (
                            <TextBox key={index} label={field.label} value={field.value} loading={loading} />
                        ))}
                    </div>
                </div>
                {(loading || !familyData?.motherDetail?.isDeceased || familyData?.guardianDetail?.isGuardianExist || familyData?.siblingDetail || familyData?.emergencyPersonDetail) && (
                    <hr className="hidden lg:block w-full bg-slate-400 border-[1px]" />
                )}
            </>}

            {(loading || !familyData?.motherDetail?.isDeceased) && <>
                <div className="flex flex-col gap-5">
                    <div className='flex items-center gap-4'>
                        <p className='lb-s whitespace-nowrap'>Mother Details</p>
                        <hr className='block lg:hidden w-full h-0.5 bg-slate-400' />
                    </div>
                    <div className='grid grid-cols-1 sm:grid-cols-2 tab:grid-cols-3 gap-5 ml-1'>
                        {motherData?.map((field, index) => (
                            <TextBox key={index} label={field.label} value={field.value} loading={loading} />
                        ))}
                    </div>
                </div>
                {(loading || familyData?.guardianDetail?.isGuardianExist || familyData?.siblingDetail || familyData?.emergencyPersonDetail) && (
                    <hr className="hidden lg:block w-full bg-slate-400 border-[1px]" />
                )}
            </>}

            {(loading || familyData?.guardianDetail?.isGuardianExist) && <>
                <div className="flex flex-col gap-5">
                    <div className='flex items-center gap-4'>
                        <p className='lb-s whitespace-nowrap'>Guardian Details</p>
                        <hr className='block lg:hidden w-full h-0.5 bg-slate-400' />
                    </div>
                    <div className='grid grid-cols-1 sm:grid-cols-2 tab:grid-cols-3 gap-5 ml-1'>
                        {guardianData?.map((field, index) => (
                            <TextBox key={index} label={field.label} value={field.value} loading={loading} />
                        ))}
                    </div>
                </div>
                {(loading || familyData?.siblingDetail || familyData?.emergencyPersonDetail) && (
                    <hr className="hidden lg:block w-full bg-slate-400 border-[1px]" />
                )}
            </>}

            {familyData?.siblingDetail && <>
                <div className='flex flex-col w-full gap-5'>
                    <div className='flex items-center gap-4'>
                        <p className='lb-s whitespace-nowrap'>Sibling Details</p>
                        <hr className='block lg:hidden w-full h-0.5 bg-slate-400' />
                    </div>
                    <div className="flex flex-col gap-5">
                        {familyData?.siblingDetail?.map((child, i) => (
                            <React.Fragment key={i}>
                                <div className="grid grid-cols-1 sm:grid-cols-2 tab:grid-cols-3 gap-5 ml-1">
                                    <TextBox label="Name" value={child?.name} loading={loading} />
                                    <TextBox label="Relation" value={child?.relation} loading={loading} />
                                    <TextBox label="Age" value={child?.age} loading={loading} />
                                </div>
                            </React.Fragment>
                        ))}
                    </div>
                </div>
                {familyData?.emergencyPersonDetail && (
                    <hr className="hidden lg:block w-full bg-slate-400 border-[1px]" />
                )}
            </>}

            {familyData?.emergencyPersonDetail && <>
                <div className="flex flex-col gap-y-5">
                    <div className='flex items-center gap-x-4'>
                        <p className='lb-s whitespace-nowrap'>Emergency Person Details</p>
                        <hr className='block lg:hidden w-full h-0.5 bg-slate-400' />
                    </div>
                    <div className='grid grid-cols-1 sm:grid-cols-2 tab:grid-cols-3 gap-5 ml-1'>
                        {emergencyPersonData?.map((field, index) => (
                            <TextBox key={index} label={field.label} value={field.value} loading={loading} />
                        ))}
                    </div>
                </div>
            </>}


            {(familyData?.fatherDetail?.isDeceased && familyData?.motherDetail?.isDeceased && !familyData?.guardianDetail?.isGuardianExist && !(!!familyData?.siblingDetail)) &&
                <div className='flex flex-col justify-center items-center p-7 xs:p-12 h-full w-full'>
                    <Lottie className='h-60' animationData={NoData} loop={true} />
                    <div className='text-s text-lg'>No admission data found.</div>
                </div>
            }
        </div>
    )
}

export default FamilyDetails;